// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-dialog {
  position: absolute;
  background-color: var(--ion-card-background, #ffffff);
  border-radius: var(--border-radius-large, 16px);
  padding: 4px 8px 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  font-size: var(--font-size-xx-small);
  min-width: 165px;
  height: auto;
  opacity: 0.95;
}

.dialog-header {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid var(--ion-border-color, rgba(0, 0, 0, 0.08));
  margin-bottom: 0;
}

.refresh-btn {
  --padding-start: 6px;
  --padding-end: 6px;
  margin: 0;
}

.refresh-label {
  font-size: var(--font-size-xx-small, 10px);
  margin-left: 2px;
}

.custom-item {
  --background: var(--ion-color-light, #f4f5f8);
  --padding-start: 8px;
  --inner-padding-end: 8px;
  height: auto;
  min-height: 68px;
  border: 1px solid var(--ion-border-color, rgba(0, 0, 0, 0.2));
  border-radius: 8px;
  margin: 6px 2px 2px;
}

.custom-input {
  font-size: var(--font-size-small, 13px);
  font-weight: bold;
}

.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60px;
  margin-top: 0;
}

.small-loader {
  width: 20px;
  height: 15px;
}

.loading-label {
  font-size: smaller;
  color: var(--ion-text-color, black);
  margin-left: 5px;
}

@media (max-width: 599px) {
  .search-dialog {
    bottom: 55px;
    left: 15px;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .search-dialog {
    top: 58px;
    right: 214px;
  }
}
@media (min-width: 1024px) {
  .search-dialog {
    top: 64px;
    right: 260px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/check-near-urban-areas/check-near-urban-areas.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,qDAAA;EACA,+CAAA;EACA,oBAAA;EACA,0CAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qEAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;AAAF;;AAGA;EACE,0CAAA;EACA,gBAAA;AAAF;;AAGA;EACE,6CAAA;EACA,oBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,6DAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,uCAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mCAAA;EACA,gBAAA;AAAF;;ACzCE;ED+CA;IACE,YAAA;IACA,UAAA;EAFF;AACF;ACzCE;ED+CA;IACE,SAAA;IACA,YAAA;EAHF;AACF;ACxCE;ED+CA;IACE,SAAA;IACA,YAAA;EAJF;AACF","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n.search-dialog {\r\n  position: absolute;\r\n  background-color: var(--ion-card-background, #ffffff);\r\n  border-radius: var(--border-radius-large, 16px);\r\n  padding: 4px 8px 8px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n  z-index: 9999;\r\n  font-size: var(--font-size-xx-small);\r\n  min-width: 165px;\r\n  height: auto;\r\n  opacity: 0.95;\r\n}\r\n\r\n.dialog-header {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-bottom: 1px solid var(--ion-border-color, rgba(0,0,0,0.08));\r\n  margin-bottom: 0;\r\n}\r\n\r\n.refresh-btn {\r\n  --padding-start: 6px;\r\n  --padding-end: 6px;\r\n  margin: 0;\r\n}\r\n\r\n.refresh-label {\r\n  font-size: var(--font-size-xx-small, 10px);\r\n  margin-left: 2px;\r\n}\r\n\r\n.custom-item {\r\n  --background: var(--ion-color-light, #f4f5f8);\r\n  --padding-start: 8px;\r\n  --inner-padding-end: 8px;\r\n  height: auto;\r\n  min-height: 68px;\r\n  border: 1px solid var(--ion-border-color, rgba(0, 0, 0, 0.2));\r\n  border-radius: 8px;\r\n  margin: 6px 2px 2px;\r\n}\r\n\r\n.custom-input {\r\n  font-size: var(--font-size-small, 13px);\r\n  font-weight: bold;\r\n}\r\n\r\n.loader-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 60px;\r\n  margin-top: 0;\r\n}\r\n\r\n.small-loader {\r\n  width: 20px;\r\n  height: 15px;\r\n}\r\n\r\n.loading-label {\r\n  font-size: smaller;\r\n  color: var(--ion-text-color, black);\r\n  margin-left: 5px;\r\n}\r\n\r\n\r\n// Breakpoints con mixins de accord-breakpoints.scss\r\n@include bp.mobile {\r\n  .search-dialog {\r\n    bottom: 55px;\r\n    left: 15px;\r\n  }\r\n}\r\n\r\n@include bp.tablet {\r\n  .search-dialog {\r\n    top: 58px;\r\n    right: 214px;\r\n  }\r\n}\r\n\r\n@include bp.desktop {\r\n  .search-dialog {\r\n    top: 64px;\r\n    right: 260px;\r\n  }\r\n}\r\n","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
